import { Heading } from '../../../typography';
import { ToastProps } from '../toast.types';

export function ToastHeader({
  header
}: {
  header: ToastProps['header'];
}): JSX.Element | null {
  if (!header) {
    return null;
  }
  return <Heading variant="h6">{header}</Heading>;
}
